module.exports = __webpack_public_path__ + "img/hairdressing_tools.89dac3ae.png";